import React from 'react';
import TextareaAutosize from 'react-autosize-textarea';

import '../styles/ocr.css';

class OCRConverter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: this.props.item.content,
      converted: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.convert = this.handleSubmit.bind(this);
    this.delete = this.handleDelete.bind(this);
    this.strip = this.strip.bind(this);
  }

  strip(e) {
    e.preventDefault();
    this.setState({content: this.state.content.replace(/\n/g, ' ')});
  }

  handleInputChange(e) {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({[name]: value});
  }

  handleDelete(e) {
    e.preventDefault();
    const that = this;
    fetch(`/api/note/${this.props.item.id}`, {
      credentials: 'same-origin',
      method: 'DELETE'
    }).then((rsp) => {
        if (rsp.status === 200) {
          that.setState({converted: true});
        }
      });
  }

  handleSubmit(e) {
    e.preventDefault();
    const that = this;
    const url = `/api/note/${this.props.item.id}`;
    const options = {
      credentials: 'same-origin',
      headers: {"Content-Type": "application/json"},
      method: 'POST',
      body: JSON.stringify({
        content: this.state.content,
        source: this.state.source,
        type: 'quote'
      })
    };
    fetch(url, options).then((res) => {
      if (res.status === 200) {
        that.setState({converted: true});
      }
    });
  }

  render() {
    if (this.state.converted) {
      return null;
    }

    return <div className='ocr-item'>
      <div className='row'>
        <div className='col-md-6'>
          {this.props.item.image_id && <img src={`/image/${this.props.item.image_id}`} />}
        </div>
        <div className='col-md-6'>
          <form>
            <div className='form-group'>
            <TextareaAutosize
              className='form-control'
              key='content-field'
              name='content'
              onChange={this.handleInputChange}
              value={this.state.content} />
            </div>
          <div className='form-group'>
          <input
            className='form-control'
            type='text'
            name='source'
            onChange={this.handleInputChange}
            placeholder='source' />
          </div>
          <div className='form-group'>
          <button className='btn-primary' onClick={this.convert}>save</button>
          <button className='btn-default' onClick={this.strip}>strip</button>
          <button className='btn-danger' onClick={this.delete}>delete</button>
          </div>
          </form>
        </div>
      </div>
    </div>;
  }
}

export default class OCRController extends React.Component {
  render() {
    return <div>
      {this.props.notes.map((n) => <OCRConverter item={n} />)}
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/controllers/OCRController.js